import { fixLocale } from '@data/page';
import i18nConfig from 'i18n.config';

export const getCorrectHeader = (
  headerData: Record<string, string> | null,
  locale: string,
): string | undefined => {
  // if is null or undefined, return null
  if (!headerData) {
    return undefined;
  }
  // if headerData is a string, then return it
  if (typeof headerData === 'string') {
    return headerData;
  }

  // if headerData is an object, then return the correct locale
  if (typeof headerData === 'object') {
    // if locale is null then then return undefined
    if (!locale) {
      return undefined;
    }
    if (headerData[locale]) {
      return headerData[locale];
    }
    const localeFixed = fixLocale(locale);
    // check if the object contains the locale
    if (headerData[localeFixed]) {
      return headerData[localeFixed];
    }

    // check if the locale is french canadian
    const isFrenchCandadian = locale === 'fr-ca' || localeFixed === 'fr-CA';
    if (isFrenchCandadian) {
      return headerData['cf'];
    }

    // check if the locale has a dash, check if the object contains the locale without the dash
    const localeDash = locale.split('-')[0]!;
    const localeFixedDash = localeFixed.split('-')[0];
    if (headerData[localeDash]) {
      return headerData[localeDash];
    } else if (headerData[localeFixedDash]) {
      return headerData[localeFixedDash];
    } else {
      return undefined;
    }
  }
};

export const preventWidows = (text) => {
  if (text == null) return '';
  const lastSpaceIndex = text?.lastIndexOf(' ');
  if (lastSpaceIndex === -1) {
    return text;
  }
  return text?.slice(0, lastSpaceIndex) + '\u00A0' + text?.slice(lastSpaceIndex + 1);
};

export const getCurrentLocale = (): string => {
  return getCookie('NEXT_LOCALE') || i18nConfig.defaultLocale;
};

export const getCookie = (name: string): string | null => {
  if (typeof document !== 'undefined') {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop()!.split(';').shift() ?? null;
    }
  }
  return null;
};

// Fallback dictionary. Meant to handle iso-639-3 codes that cannot be properly handled by Intl.DisplayNames
export const fallbackLanguageDictionary = {
  cmn: {
    en: 'Mandarin',
    'fr-CA': 'mandarin',
    es: 'mandarín',
  },
};
